import { render, staticRenderFns } from "./tradeAccount__form.vue?vue&type=template&id=2418789d"
import script from "./tradeAccount__form.vue?vue&type=script&lang=js"
export * from "./tradeAccount__form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports